import React, { useMemo } from 'react'
import Header from '../../components/layout/header/Header'
import { Link } from 'react-router'
import Lens from '../../images/lensImage.png'
import FrameIMage from '../../images/frame.png'
import { Image } from 'react-bootstrap'
import { useGetTrackingHistoryQuery } from '../../app/orderApi/OrderApi'
import CaptifyProImage from '../../images/captify_pro_product.jpg'
import CaptifyMyvuImage from '../../images/captify_myvu_product.jpg'
import CaptifyProSunglassImage from '../../images/captify_pro_sunglass_black.jpg'
import CaptifyProSunglassImageBrown from '../../images/captify_pro_sunglass_clip_on_brown.jpg'
import CaptifyMyvuSunglassImageBrown from '../../images/captify_myvu_sunglasses_brown.png'
import CaptifyMyvuSunglassImage from '../../images/captify_myvu_sunglasses_black.png'
import DefaultProductImage from '../../images/captify-favicon.svg'
import { useLocation } from 'react-router'

function getProductImageSrc(product) {
  const sku = String(product?.skuName || "").toLowerCase();
  const productType = String(product?.productType || "").toLowerCase();

  if (sku.includes("sunglass") && sku.includes("captify pro") && sku.includes("brown")) {
    return CaptifyProSunglassImageBrown;
  }
  if (sku.includes("sunglass") && sku.includes("captify pro")) {
    return CaptifyProSunglassImage;
  }
  if (sku.includes("sunglass") && sku.includes("captify myvu") && sku.includes("brown")) {
    return CaptifyMyvuSunglassImageBrown;
  }
  if (sku.includes("sunglass") && sku.includes("captify myvu")) {
    return CaptifyMyvuSunglassImage;
  }
  if (sku.includes("captify pro")) {
    return CaptifyProImage;
  }
  if (sku.includes("captify myvu")) {
    return CaptifyMyvuImage;
  }
  if (productType === "lens") {
    return Lens;
  }
  if (productType === "frame") {
    return FrameIMage;
  }
  return DefaultProductImage;
}

const OrderStatusView = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const trackingId = queryParams.get("id");

  const { data, isLoading, error } = useGetTrackingHistoryQuery(
    { ShopifyID: trackingId },
    { skip: !trackingId }
  );

  // group timeline data by formattedDate
  const groupedTimeline = useMemo(() => {
    const timeline = data?.data?.timeline ?? [];
    const grouped = timeline.reduce((acc, item) => {
      const date = item.formattedDate || "";
      if (!acc[date]) acc[date] = [];
      acc[date].push(item);
      return acc;
    }, {});
    return Object.entries(grouped).map(([formattedDate, items]) => ({
      formattedDate,
      items
    }));
  }, [data]);

  if (isLoading) return null;
  if (error) return <div>Error fetching tracking info</div>;

  const supportEmail = data?.data?.supportEmail === 'va@captify.glass'
    ? 'va@captify.glass'
    : 'support@captify.glass';

  return (
    <div className='userWrapper'>
      <Header />
      <div className='order-status-wrapper mt-5'>
        <h1 className='cpt-title'>Order status</h1>
        <p className='presc-desc'>
          If you have any questions about this form, please email us at{' '}
          <Link to={`mailto:${supportEmail}`}>{supportEmail}</Link>
        </p>

        <div className="shipping-card">
          <div className='d-flex gap-3 justify-content-between shipping-card-title'>
            <h4>Shipping product</h4>
            <div className="pieces">
              {data?.data?.products?.length ?? 0}{" "}
              {(data?.data?.products?.length ?? 0) === 1 ? "Item" : "Items"}
            </div>
          </div>

          <div className="shipping-header">
            <div className="product-info">
              {data?.data?.products?.length > 0 &&
                data.data.products.map((curElement, index) => {
                  const productImage = getProductImageSrc(curElement);
                  return (
                  <div className="product" key={index}>
                    <span className="icon">
                      <Image
                        src={productImage}
                        alt={curElement?.skuName || "product"}
                        width={48}
                        height={48}
                      />
                    </span>
                    <span>{curElement?.skuName}</span>
                  </div>
                  );
                })}
            </div>
          </div>

          <h4>Shipping status</h4>
          <div className="timeline">
            {groupedTimeline.map((group, groupIndex) => (
              <div key={groupIndex} className="timeline-group">
                <h5 className="date-heading">{group.formattedDate}</h5>
                {group.items.map((timelineData, index) => (
                  <div className="" key={index}>
                    <div className={`${timelineData?.dotClass} timeline-dot filled`}></div>
                    <div className="timeline-content">
                      <div className="status-info">
                        <span className="highlight d-block">{timelineData?.title}</span>
                        <p>{timelineData?.description}</p>

                        {timelineData?.abnormalReasons?.length > 0 &&
                          timelineData.abnormalReasons.map((errorText, i) => (
                            <p key={i} className='text-danger'>{errorText}</p>
                          ))}

                        {timelineData?.location && (
                          <p>📍 {timelineData.location}</p>
                        )}
                        {timelineData?.formattedTime && (
                          <span className="time">
                            {timelineData.formattedDate} {timelineData.formattedTime}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderStatusView
